import { Pipe, PipeTransform, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Pipe({ name: 'kebab' })
export class KebabCasePipe implements PipeTransform {
    transform(str: string): string {
        return str && str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/\s+/g, '-').toLowerCase();
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/kebab.pipe.ts